import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { Construction, ArrowLeft, Clock, CheckCircle, Calendar } from 'lucide-react';

export const InnovaTrackPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50">
      <Header />
      
      <main className="max-w-5xl mx-auto px-4 py-20">
        {/* Back Button */}
        <Button
          onClick={() => window.location.href = '/'}
          variant="ghost"
          className="mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Button>

        {/* Construction Banner */}
        <div className="text-center mb-12">
          <div className="inline-block p-6 bg-gradient-to-br from-green-600 to-green-800 rounded-full mb-6 animate-pulse">
            <Construction className="w-16 h-16 text-white" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-green-700 to-blue-600 bg-clip-text text-transparent">
            Innova-Track
          </h1>
          <p className="text-xl text-gray-600">
            Logiciel de gestion des heures de travaux communautaires
          </p>
        </div>

        {/* Under Development Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
            <h2 className="text-2xl font-bold text-gray-800">En Développement</h2>
          </div>
          
          <p className="text-lg text-gray-600 text-center mb-8">
            Notre équipe travaille activement sur ce logiciel innovant pour vous offrir la meilleure solution de gestion des heures de travaux communautaires.
          </p>

          {/* Features Preview */}
          <div className="grid md:grid-cols-2 gap-6 mt-8">
            <div className="flex items-start gap-4 p-4 bg-green-50 rounded-xl">
              <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <Clock className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Suivi des heures en temps réel</h3>
                <p className="text-sm text-gray-600">Enregistrement précis et automatique des heures de travail</p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <CheckCircle className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Validation automatique</h3>
                <p className="text-sm text-gray-600">Système de validation intégré pour les superviseurs</p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-purple-50 rounded-xl">
              <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <Calendar className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Rapports détaillés</h3>
                <p className="text-sm text-gray-600">Génération de rapports complets et exportables</p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-orange-50 rounded-xl">
              <div className="w-10 h-10 bg-orange-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <CheckCircle className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Interface intuitive</h3>
                <p className="text-sm text-gray-600">Facile à utiliser pour tous les utilisateurs</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="bg-gradient-to-r from-green-600 to-blue-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Intéressé par Innova-Track?</h3>
          <p className="mb-6 text-green-50">
            Contactez-nous pour être informé du lancement et bénéficier d'une offre spéciale
          </p>
          <Button
            onClick={() => window.location.href = '/#contact'}
            className="bg-white text-green-700 hover:bg-green-50 px-8 py-6 text-lg"
          >
            Nous contacter
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};
